var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderPrivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "29px",
    viewBox: "0 0 32 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#203D5E",
    x: 7,
    y: 2,
    width: 21,
    height: 11,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4312313,5.08081612 L15.0274021,5.08081612 C14.7915155,5.0826695 14.570262,4.96231334 14.4422612,4.76419091 L12.1016975,1.17578457 C11.6262822,0.442536777 10.8180387,0 9.95128117,0 L2.56914318,0 C1.15019983,0.00555541026 0.00182563971,1.17023864 0,2.60706113 L0,26.3929389 C0.00183032083,27.8297614 1.15015301,28.9944541 2.56914318,29 L29.4308568,29 C30.8498002,28.9944446 31.9981744,27.8297614 32,26.3929389 L32,7.68798627 C31.9981697,6.25116378 30.849847,5.08647107 29.4308568,5.08092514 L29.4312313,5.08081612 Z",
    id: "Fill-1",
    fill: "#4788D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderPrivate);
export default __webpack_public_path__ + "static/media/folder-private.3427c01202ed37af88dd86c080fae67d.svg";
export { ForwardRef as ReactComponent };